export enum CallDirectionEnum {
  Unknown = 0,
  Inbound = 1,
  Outbound = 2,
}

export const CallDirectionDisplayName = {
  [CallDirectionEnum.Unknown]: 'Unknown',
  [CallDirectionEnum.Inbound]: 'Inbound',
  [CallDirectionEnum.Outbound]: 'Outbound',
};
